<template>
  <div class="c-world-clock-analog">
    <highcharts :options="chartOptions" :callback="animateClock"></highcharts>
  </div>
</template>

<script>
import { toTimezoneDate } from '@/utils/date';

export default {
  name: 'c-world-clock-analog',
  props: {
    timeZone: String
  },
  data() {
    return {
      intervalId: null,
      chartOptions: {
        chart: {
          type: 'gauge',
          plotBackgroundColor: null,
          plotBackgroundImage: null,
          plotBorderWidth: 0,
          plotShadow: false,
          height: '130',
          styledMode: true,
          padding: 0,
          margin: 0
        },
        credits: {
          enabled: false
        },
        title: {
          text: ''
        },
        yAxis: {
          labels: {
            distance: -20
          },
          min: 0,
          max: 12,
          lineWidth: 1,
          showFirstLabel: false,
          minorTickInterval: 'auto',
          minorTickWidth: 1,
          minorTickLength: 6,
          minorTickPosition: 'inside',
          minorGridLineWidth: 0,
          tickInterval: 1,
          tickWidth: 2,
          tickPosition: 'inside',
          tickLength: 10
        },
        tooltip: {
          formatter: function() {
            return this.series.chart.tooltipText;
          }
        },
        series: [
          {
            data: [
              {
                id: 'hours',
                y: 0,
                dial: {
                  radius: '60%',
                  baseWidth: 4,
                  baseLength: '95%',
                  rearLength: 0
                }
              },
              {
                id: 'minutes',
                y: 0,
                dial: {
                  baseLength: '95%',
                  rearLength: 0
                }
              },
              {
                id: 'seconds',
                y: 0,
                dial: {
                  radius: '100%',
                  baseWidth: 1,
                  rearLength: '20%'
                }
              }
            ],
            animation: false,
            dataLabels: {
              enabled: false
            }
          }
        ]
      }
    };
  },
  computed: {
    computedTZ() {
      return this.timeZone || this.$store.state.applicationSettings.general.settings.timezone;
    }
  },
  watch: {
    computedTZ: {
      immediate: true,
      handler: 'onUpdateClock'
    }
  },
  methods: {
    onUpdateClock() {
      //window.clearInterval(this.intervalId);
      const timeInfo = this.getTimeInfo();
      this.chartOptions.series[0].data.forEach(item => {
        Object.assign(item, {
          y: timeInfo[item.id]
        });
      });
    },
    animateClock(chart) {
      this.intervalId = window.setInterval(() => {
        const timeInfo = this.getTimeInfo();

        if (chart.axes) {
          const hour = chart.get('hours');
          const minute = chart.get('minutes');
          const second = chart.get('seconds');

          const animation =
            timeInfo.seconds === 0
              ? false
              : {
                  easing: pos => {
                    if (pos < 1 / 2.75) {
                      return 7.5625 * pos * pos;
                    }
                    if (pos < 2 / 2.75) {
                      return 7.5625 * (pos -= 1.5 / 2.75) * pos + 0.75;
                    }
                    if (pos < 2.5 / 2.75) {
                      return 7.5625 * (pos -= 2.25 / 2.75) * pos + 0.9375;
                    }
                    return 7.5625 * (pos -= 2.625 / 2.75) * pos + 0.984375;
                  }
                };

          chart.tooltipText = '';

          hour.update(timeInfo.hours, true, animation);
          minute.update(timeInfo.minutes, true, animation);
          second.update(timeInfo.seconds, true, animation);
        }
        this.$emit('timer', timeInfo);
      }, 1000);
    },

    getTimeInfo() {
      const date = toTimezoneDate(this.computedTZ);
      return {
        date,
        hours: date.getHours() + date.getMinutes() / 60,
        minutes: (date.getMinutes() * 12) / 60 + (date.getSeconds() * 12) / 3600,
        seconds: (date.getSeconds() * 12) / 60
      };
    },

    addPadding(number, length) {
      return new Array((length || 2) + 1 - String(number).length).join(0) + number;
    }
  },
  beforeDestroy() {
    window.clearInterval(this.intervalId);
  }
};
</script>

<style lang="scss">
@import '~@/styles/components/custom/c-world-clock-analog';
</style>
